import HTTP from './http-interceptor';
import { MATERIALES_APOYO } from '../constants';

const SupportMaterialsService = {
    
    get: (area, player) => {
        return HTTP.get(`${MATERIALES_APOYO.GET}${area}/${player}`);
    },
    isViewed: (area, player, material) => {
        const data = { 
            area, 
            material,
            jugador: player,
        };
        return HTTP.post(`${MATERIALES_APOYO.VISTO}`, data);
    },
    getLike: (area, player, material) => {
        return HTTP.get(`${MATERIALES_APOYO.LIKE}${area}/${material}/${player}`);
    },
    handleLike: (area, player, material) => {
        const data = { 
            area, 
            material,
            jugador: player,
        };
        return HTTP.post(`${MATERIALES_APOYO.LIKE}`, data);
    },
}

export default SupportMaterialsService;